import * as _ from "lodash";
import * as angular from "angular";
import { WorkflowService } from "../services/workflow.service";

export class WorkflowDataProvider {
    private $q: any;
    private service: WorkflowService;

    constructor($q: any, WorkflowService: WorkflowService) {
        this.$q = $q;
        this.service = WorkflowService;
    }

    update(data: any): Promise<any> {
        const deferred = this.$q.defer();
        this.service.update(data).then(
            (response: any) => {
                const json = response["data"];
                if (json.success) {
                    angular.extend(data, json.data.attributes);
                    deferred.resolve(data);
                } else {
                    deferred.reject(json);
                }
            },
            (error) => deferred.reject(error)
        );
        return deferred.promise;
    }

    delete(data: any): Promise<any> {
        const deferred = this.$q.defer();
        this.service.delete({ id: data.id }).then((response) => {
            const json = response["data"];
            if (json.success) {
                deferred.resolve(json.data);
            } else {
                deferred.reject(json);
            }
        });
        return deferred.promise;
    }
}

angular
    .module("vcDataProvider")
    .service("WorkflowDataProvider", WorkflowDataProvider);
